import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <Header />

      <main className="about-main">
        <div className="about-hero">
          <div className="about-hero-inner">
            <h1>About Boventraix</h1>
            <p className="about-lead">
              We design, source, market and sell clothing, shoes, accessories
              and beauty products for young fashion lovers worldwide. We move
              fast, follow trends closely and believe great fashion should be
              accessible to everyone.
            </p>
          </div>
        </div>

        <div className="about-content">
          <div className="about-section">
            <div className="about-text">
              <h2>Our Story</h2>
              <p>
                From our beginnings to a global family of brands, we’ve always
                aimed to bring the latest trends to our customers quickly and
                affordably. Our design teams spot what’s next and our supply
                chain moves to make it real.
              </p>
              <p>
                We operate a group of fashion brands across multiple markets.
                Our digital-first approach enables us to reach customers
                directly and keeps our focus on great product, strong value and
                excellent customer service.
              </p>
            </div>
            <div className="about-media">
              <img src="/main/main6.webp" alt="About hero" />
            </div>
          </div>

          <div className="about-section reverse">
            <div className="about-media">
              <img src="/main/main2-1.webp" alt="Our approach" />
            </div>
            <div className="about-text">
              <h2>Our Approach</h2>
              <p>
                We design with speed, staying on top of trends to create product
                customers want. Our cross-functional teams—from design to buying
                to digital—work together to move from concept to commerce
                quickly.
              </p>
              <p>
                Sustainability is an ongoing focus across our operations — from
                sourcing to packaging — and we continue to make incremental
                improvements to reduce our environmental impact.
              </p>
            </div>
          </div>

          <div className="about-stats">
            <div className="stat">
              <strong>Global</strong>
              <div>Multiple markets worldwide</div>
            </div>
            <div className="stat">
              <strong>Brands</strong>
              <div>Boventraix, PrettyLittleThing, Nasty Gal & more</div>
            </div>
            <div className="stat">
              <strong>Fast</strong>
              <div>New styles added daily</div>
            </div>
          </div>

          <div className="about-cta">
            <h3>Careers & Opportunities</h3>
            <p>
              We’re always looking for talented people to join our teams. View
              current vacancies and learn more about working with us.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default About;
